// Top-of-app banner that appears when the device goes offline and hides
// silently once the network comes back. Mounted in App.tsx so it renders
// across every route, including auth pages.

import { AnimatePresence, motion } from "framer-motion";
import { WifiOff } from "lucide-react";
import { useNetworkStatus } from "@/lib/network";

const OfflineBanner = () => {
  const status = useNetworkStatus();
  const offline = !status.connected;

  return (
    <AnimatePresence>
      {offline && (
        <motion.div
          key="offline"
          role="status"
          aria-live="polite"
          initial={{ y: -40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -40, opacity: 0 }}
          transition={{ duration: 0.18 }}
          className="fixed top-0 inset-x-0 z-[100] flex justify-center pointer-events-none"
        >
          <div className="mt-2 max-w-md w-[calc(100%-2rem)] rounded-lg border border-muted/40 bg-card/90 backdrop-blur-md px-3 py-2 flex items-center gap-2 shadow-lg pointer-events-auto">
            <WifiOff className="w-4 h-4 text-muted-foreground shrink-0" />
            <p className="text-[12px] text-muted-foreground leading-tight">
              You're offline. Some features unavailable.
            </p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default OfflineBanner;
